import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from 'app/main/pages/authentication/auth-guard.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    MatAutocompleteModule,
    MatButtonModule, MatDatepickerModule, MatDividerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatRadioModule, MatSelectModule, MatSlideToggleModule, MatStepperModule, MatTabsModule,
    MatTooltipModule
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TableModule } from 'primeng/table';
import { PerformanceOverviewComponent } from './performance-overview.component';
import { MultiSelectModule } from 'primeng/primeng';
import { PerformanceReviewComponent } from './performance-review/performance-review.component';

const routes = [
    { path: '', redirectTo: 'performance-review', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'performance-review', component: PerformanceOverviewComponent, canActivate: [AuthGuardService] },
    { path: 'create-review', component: PerformanceReviewComponent, canActivate: [AuthGuardService] },
];

@NgModule({
    declarations: [
        PerformanceOverviewComponent,
        PerformanceReviewComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        NgxChartsModule,
        BrowserAnimationsModule,
        MatProgressBarModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatStepperModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        FlexLayoutModule,
        TableModule,
        MatSlideToggleModule,
        MatIconModule,
        MatTabsModule,
        MatDividerModule,
        MatSelectModule,
        MatDatepickerModule,
        MatRadioModule,
        MultiSelectModule,
        MatAutocompleteModule
    ]
})
export class PerformanceOverViewModule { }
